module.exports = __webpack_public_path__ + "static/media/COLB-Screenshot-1.f483b0c0.png";